import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { sanitize } from 'dompurify';

@Pipe({
  name: 'sanitizeHtml',
})
export class HtmlSanitizerPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any): any {
    const sanitizedContent = sanitize(value);
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }
}

@NgModule({
  declarations: [HtmlSanitizerPipe],
  imports: [CommonModule],
  exports: [HtmlSanitizerPipe],
})
export class HtmlSatinizerPipeModule {}
